export default {
  dimensions: { height: 0, width: 0 },
  hotspotColor: 'rgba(137, 183, 244, 0.25)',
  hotspotList: ['rgba(137, 183, 244, 0.25)'],
  imageUrl: '',
  multipleCorrect: true,
  outlineColor: 'blue',
  outlineList: ['blue'],
  partialScoring: false,
  prompt: '',
  promptEnabled: true,
  rationaleEnabled: true,
  shapes: { rectangles: [], polygons: [], circles: [] },
  strokeWidth: 5,
  studentInstructionsEnabled: true,
  teacherInstructions: '',
  teacherInstructionsEnabled: true,
  toolbarEditorPosition: 'bottom',
};
